import fetch from 'services/request';
import {
  CreatePromotionRequest,
  PromotionStatus,
  IUpdateLoyaltyItem,
  UpdatePromotionRequest,
  IUpdateReferralConfig,
} from './types';
const API_V1 = '/api/v1';
const SETTING_BASE_URL = API_V1 + '/setting';
const PROMOTION_BASE_URL = API_V1 + '/promotion';

export interface ITaxSettingsPayload {
  id: string;
  enableSaleTax: boolean;
  saleTaxPercent: number;
  enableUsedTax: boolean;
  usedTaxPercent: number;
}

export interface IDiscountSettingsPayload {
  id: string;
  enable: boolean;
  discountType: string;
  discountValue: number;
}

export interface IFeeCreditCardPayload {
  id: string;
  enable: boolean;
  feeType: string;
  feeValue: number;
}

export interface IGetPromotionsParams {
  page?: number;
  size?: number;
  title?: string;
  status?: PromotionStatus | undefined;
}

// API endpoints
const api = {
  tax: {
    get: () =>
      fetch({
        method: 'get',
        url: `${SETTING_BASE_URL}/setting-tax`,
      }),
    update: (payload: ITaxSettingsPayload) =>
      fetch({
        method: 'post',
        url: `${SETTING_BASE_URL}/setting-tax`,
        body: payload,
      }),
  },
  discount: {
    get: () =>
      fetch({
        method: 'get',
        url: `${SETTING_BASE_URL}/cash-discount-incentive`,
      }),
    update: (payload: IDiscountSettingsPayload) =>
      fetch({
        method: 'post',
        url: `${SETTING_BASE_URL}/cash-discount-incentive`,
        body: payload,
      }),
  },
  feeCreditCard: {
    get: () =>
      fetch({
        method: 'get',
        url: `${SETTING_BASE_URL}/fee-credit-card`,
      }),
    update: (payload: IFeeCreditCardPayload) =>
      fetch({
        method: 'post',
        url: `${SETTING_BASE_URL}/fee-credit-card`,
        body: payload,
      }),
  },
  loyalty: {
    get: () =>
      fetch({
        method: 'get',
        url: `${SETTING_BASE_URL}/get-loyalty-program`,
      }),
    update: (payload: IUpdateLoyaltyItem[]) =>
      fetch({
        method: 'post',
        url: `${SETTING_BASE_URL}/update-loyalty-program`,
        body: payload,
      }),
  },
  promotion: {
    get: {
      list: (params: IGetPromotionsParams = { page: 1, size: 20 }) =>
        fetch({
          method: 'get',
          url: `${PROMOTION_BASE_URL}/list`,
          params: {
            page: params.page,
            size: params.size,
            title: params.title,
            status: params.status,
          },
        }),
      detail: (id: string) =>
        fetch({
          method: 'get',
          url: `${PROMOTION_BASE_URL}/detail/${id}`,
        }),
    },
    create: (payload: CreatePromotionRequest) =>
      fetch({
        method: 'post',
        url: `${PROMOTION_BASE_URL}/create`,
        body: payload,
      }),
    update: (payload: UpdatePromotionRequest) =>
      fetch({
        method: 'post',
        url: `${PROMOTION_BASE_URL}/update`,
        body: payload,
      }),
    delete: (ids: string[]) =>
      fetch({
        method: 'post',
        url: `${PROMOTION_BASE_URL}/delete`,
        body: ids,
      }),
  },
  referral: {
    get: () =>
      fetch({
        method: 'get',
        url: `${SETTING_BASE_URL}/setting-referral`,
      }),
    update: (payload: IUpdateReferralConfig[]) =>
      fetch({
        method: 'post',
        url: `${SETTING_BASE_URL}/setting-referral`,
        body: payload,
      }),
  },
};

export default api;
